import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import styles from "./ForgetPassword.module.css";
import { AntdInput, AntdPassInput, AntdSubmit, Box, InputField, SubmitButton, TextComponent } from "../../../components";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
// import forgetBackImg from "../../assets/forgetBackImg.png";
const ForgetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState();

  const handleOnForgot = ()=>{
    let userData = {
      email: email
    }
    if(!email){
      dispatch(
        showAlert({ type: "Error", message: "Email Field is Required!" })
      );
    }else{
      dispatch(AuthMiddleware.forgetPassword(userData)).then((data)=>{
        navigate('/verificationCode',{
          state: data?.data
        })
        
      }).catch((err)=>{
        console.log("error===>>>", err);
      });
    } 
  }
  return (
    <Box boxClass={styles.box}>
      <div className={styles.header}>
        <IoIosArrowBack color="var(--black-color)" size={30} style={{cursor: 'pointer'}} onClick={()=>navigate('/')}/>
      </div>
      <div className={styles.headingDiv}>
      <TextComponent text={"Forget Password"} textClass={styles.heading} />
      <TextComponent text={"Enter registered email address to receive password recovery link."} textClass={styles.subHeading} />
      <InputField value={email} onChange={(e)=>setEmail(e.target.value)} label="Email Address" placeholder={"email@bestdayever.com"} />
      <SubmitButton title={"Send"} btnClass={styles.btn} onClick={handleOnForgot} />

      </div>
    </Box>
  );
};
export default ForgetPassword;
